export default "__VITE_ASSET__CRgm5llq__"